<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="filter_header" :viewName="viewName" :view_filters="view_filters"
                        v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-row v-if="selectedItems && selectedItems.length > 0 && !roleCustomer" class="mb-2 ml-1">
                        <v-col cols="auto" v-if="currentPath.includes('nhap-kho-tq') && !roleStoreTQ">
                            <v-btn color="primary" @click="changeStatusSelectedProducts">
                                <v-icon left>mdi-sync</v-icon>
                                Chuyển trạng thái ({{ selectedItems.length }})
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn color="success" @click="exportSelectedItems">
                                <v-icon left>mdi-download</v-icon>
                                Xuất Excel ({{ selectedItems.length }})
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn color="info" @click="openTruckDialog">
                                <v-icon left>mdi-truck</v-icon>
                                Xếp xe
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="blue" text-color="white" small>
                                <v-icon left small>mdi-package-variant-closed</v-icon>
                                {{ selectedItemsNumberOfPack | currency }} kiện
                            </v-chip>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="orange" text-color="white" small>
                                <v-icon left small>mdi-weight-kilogram</v-icon>
                                {{ selectedItemsWeight | currency('', 1) }} kg
                            </v-chip>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="green" text-color="white" small>
                                <v-icon left small>mdi-cube-outline</v-icon>
                                {{ selectedItemsVolume | currency('', 3) }} m³
                            </v-chip>
                        </v-col>
                        <v-col cols="auto" v-if="currentPath.includes('ma-hang-tmdt') && adminRole">
                            <v-btn color="primary" @click="triggerFileUpload" :loading="isUploading">
                                <v-icon left>mdi-upload</v-icon>
                                {{ $t('actions.import_excel') }}
                            </v-btn>
                            <input type="file" ref="fileInput" style="display: none" accept=".xls,.xlsx" @change="onFileSelected">
                        </v-col>
                    </v-row>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100" show-select item-key="ID" v-model="selectedItems"
                        fixed-header height="calc(100vh - 300px)">
                        <template v-slot:item="{ item, isSelected, select }">
                            <tr :active="isSelected" :id="'r-' + item.ID" :style="{ 'background-color': !item.Weight && !item.Volume ? '#fae6e696' : '' }" v-if="!currentPath.includes('ma-hang-tmdt')">
                                <td @click="select(!isSelected)"><v-checkbox primary hide-details
                                        :input-value="isSelected"></v-checkbox></td>
                                <td>{{ item.CustomerName }}</td>
                                <td>{{ item.SaleName || '-' }}</td>
                                <td>{{ item.GoodsType == 1 ? '' : item.PartnerName }}</td>
                                <td>{{ item.GoodsType == 1 ? '' : (item.QuoteCount > 0 ? 'Đã có khai báo' : '') }}</td>
                                <td>{{ item.Note }}</td>
                                <td>{{ item.GoodsType == 1 ? '' : item.ProductNameCN }}</td>
                                <td>
                                    <p v-html="item.OrderCodes"></p>
                                </td>
                                <td>
                                    <p v-html="item.BillCodes"></p>
                                </td>
                                <td class="text-right">
                                    <v-tooltip right color="grey lighten-3" transition="expand-transition" max-width="500">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on" v-if="currentPath.includes('ton-kho-tq')">{{
                                                ((item.NumberOfPack | 0) -(item.NumberOfPackTruck | 0)) | currency
                                                }}</span>
                                            <span v-on="on" v-else-if="currentPath.includes('ton-kho-vn')">{{
                                                ((item.NumberOfPackImport | 0) -(item.NumberOfPackExport | 0)) | currency
                                                }}</span>
                                            <span v-on="on" v-else>{{ item.NumberOfPack | currency }}</span>
                                        </template>
                                        <!-- Hiển thị lịch sử xuất hàng nếu currentPath là xuat-kho-vn -->
                                        <span v-if="currentPath.includes('xuat-kho-vn')">
                                            <v-list width="480" color="transparent" dense>
                                                <v-list-item>
                                                    <v-list-item-title class="font-weight-bold">Lịch sử xuất hàng</v-list-item-title>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <template v-if="item.ExportHistory && item.ExportHistory.length > 0">
                                                    <v-list-item v-for="(history, idx) in item.ExportHistory" :key="idx">
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ history.BillCode }} - {{ history.ExportDate | display_date('DD-MM-YYYY') }}</v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                Số kiện: {{ history.NumberOfPack | currency }} | 
                                                                Cân nặng: {{ history.Weight | currency('', 1) }} kg | 
                                                                Thể tích: {{ history.Volume | currency('', 3) }} m³
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                                <v-list-item v-else>
                                                    <v-list-item-subtitle class="text-center grey--text">Chưa có lịch sử xuất hàng</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>
                                                            Tổng kiện: {{ item.NumberOfPack | currency }} | 
                                                            Đã xuất: {{ item.NumberOfPackExport | currency }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </span>
                                    </v-tooltip>
                                </td>
                                <td class="text-right" v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{ item.NumberOfPackTruck | currency }}</td>
                                <td class="text-right" v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{ (item.NumberOfPack - item.NumberOfPackTruck) | currency }}</td>
                                <td>{{ item.SuffixBill }}</td>
                                <td class="text-right">
                                    <v-tooltip right color="grey lighten-3" transition="expand-transition">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.Deposit | currency('', 2) }}</span>
                                        </template>
                                        <span>
                                            <v-list width="350" color="transparent">
                                                <v-list-item>
                                                    <v-list-item-title>Ship nội địa: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.TransactionDeposit | currency('¥',
                                                        2)}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Chi xe kéo: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.PedicabDeposit | currency('¥',
                                                        2)}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Chi xe nâng: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.LoadDeposit | currency('¥',
                                                        2)}}</v-list-item-subtitle>
                                                </v-list-item>
                                            </v-list>
                                        </span>
                                    </v-tooltip>
                                </td>
                                <td class="text-right">{{ getDisplayWeight(item) | currency('', 1) }}</td>
                                <td class="text-right">{{ getDisplayVolume(item) | currency('', 3) }}</td>
                                <td class="text-right">{{ item.TotalFeeWeight | currency }}</td>
                                <td class="text-right">{{ item.ImportTaxAmount | currency }}</td>
                                <td class="text-right">{{ item.VatTaxAmount | currency }}</td>
                                <td class="text-right">{{ item.ServiceFeeAmount | currency }}</td>
                                <td class="text-right" v-if="adminRole">{{ item.TotalCostWeight | currency }}</td>
                                <td class="text-right" v-if="adminRole">{{ item.TotalProfit | currency }}</td>
                                <td class="text-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" medium :color="item.IsSplitTax ? 'red' : 'gray'" >circle</v-icon>
                                        </template>
                                        <span>{{ $t('table_headers.is_split_tax') }}</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon style="cursor: pointer;" v-on="on" medium :color="item.IsSentCustoms ? 'blue' : 'gray'" @click="saveItem({ ID: item.ID, IsSentCustoms: !item.IsSentCustoms })">circle</v-icon>
                                        </template>
                                        <span>{{$t('export.send_custom')}}</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon style="cursor: pointer;" v-on="on" medium :color="item.IsReady ? 'green' : 'gray'" @click="saveItem({ ID: item.ID, IsReady: !item.IsReady })">circle</v-icon>
                                        </template>
                                        <span>{{$t('table_headers.is_ready')}}</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    {{ item.ReceiveDate | display_date('DD-MM-YYYY') }}
                                    <br />
                                    {{ item.PackDate | display_date('DD-MM-YYYY') }}
                                </td>
                                <td>
                                    {{ item.StoreCNExpDate | display_date('DD-MM-YYYY') }}
                                    <br />
                                    {{ item.PaymentDate | display_date('DD-MM-YYYY') }}
                                </td>
                                <td v-if="(adminRole || csRole) && item.Status != product_status.xuat_du">
                                    <v-edit-dialog :return-value.sync="item.Status" large lazy persistent
                                        @save="saveItem({ ID: item.ID, Status: item.Status })">
                                        <div :style="{'color': display_color(item.Status, product_status_list)}">{{ item.Status | display_value(product_status_list) }}</div>
                                        <template v-slot:input>
                                            <v-select v-model="item.Status" :items="product_status_list"
                                                :item-text="p => p.i18n ? $t(p.i18n) : p.name" item-value="value" :label="$t('form.status')" class="ma-1">
                                            </v-select>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else :style="{'color': display_color(item.Status, product_status_list)}">{{ item.Status | display_value(product_status_list) }}</td>
                                <td>{{ item.StoreID | display_value(storages, 'ID', 'Name') }}</td>
                                <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                                <td class="text-center">
                                    <table-action-buttons :actions="getProductActions(item)"></table-action-buttons>
                                </td>
                            </tr>
                        
                            <tr :active="isSelected" :id="'r-' + item.ID" :style="{ 'background-color': !item.Weight && !item.Volume ? '#fae6e696' : '' }" v-else>
                                <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                                <td>{{ item.TrackingCode || '-' }}</td>
                                <td>{{ item.CustomerName }}</td>
                                <td>{{ item.BigPackageCode || '-' }}</td>
                                <td><p v-html="item.OrderCodes || '-'"></p></td>
                                <td class="text-right">{{ getDisplayWeight(item) | currency('', 1) }}</td>
                                <td>{{ item.Length }} x {{ item.Width }} x {{ item.Height }}</td>
                                <td class="text-right">{{ getDisplayVolume(item) | currency('', 3) }}</td>
                                <td class="text-right">{{ getDisplayNumberOfPack(item) | currency }}</td>
                                <td v-if="(adminRole || csRole) && item.Status != product_status.xuat_du">
                                    <v-edit-dialog :return-value.sync="item.Status" large lazy persistent
                                        @save="saveItem({ ID: item.ID, Status: item.Status })">
                                        <div :style="{'color': display_color(item.Status, product_status_list)}">{{ item.Status | display_value(product_status_list) }}</div>
                                        <template v-slot:input>
                                            <v-select v-model="item.Status" :items="product_status_list"
                                                :item-text="p => p.i18n ? $t(p.i18n) : p.name" item-value="value" :label="$t('form.status')" class="ma-1">
                                            </v-select>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else :style="{'color': display_color(item.Status, product_status_list)}">{{ item.Status | display_value(product_status_list) }}</td>
                                <td>
                                     <div v-if="item.CreatedDate" class="text-caption">{{ $t('tmdt_form.date_created') }}: {{ item.CreatedDate | display_date('DD-MM-YYYY') }}</div>
                                     <div v-if="item.ReceiveDate" class="text-caption">{{ $t('tmdt_form.date_store_cn') }}: {{ item.ReceiveDate | display_date('DD-MM-YYYY') }}</div>
                                     <div v-if="item.PackDate" class="text-caption">{{ $t('tmdt_form.date_pack') }}: {{ item.PackDate | display_date('DD-MM-YYYY') }}</div>
                                     <div v-if="item.StoreCNExpDate" class="text-caption">{{ $t('tmdt_form.date_store_cn_exp') }}: {{ item.StoreCNExpDate | display_date('DD-MM-YYYY') }}</div>
                                     <div v-if="item.VNDate" class="text-caption">{{ $t('tmdt_form.date_store_vn') }}: {{ item.VNDate | display_date('DD-MM-YYYY') }}</div>
                                     <div v-if="item.StoreVNExpDate" class="text-caption">{{ $t('tmdt_form.date_store_vn_exp') }}: {{ item.StoreVNExpDate | display_date('DD-MM-YYYY') }}</div>
                                 </td>
                                <td class="text-center">
                                    <table-action-buttons :actions="getTmdtActions(item)"></table-action-buttons>
                                </td>
                            </tr>
</template>
                        <template slot="body.append">
                            <tr v-if="summary && !currentPath.includes('ma-hang-tmdt')" class="total-summary-td">
                                <td colspan="9" class="text-center font-weight-bold">Tổng</td>
                                <td class="text-end font-weight-bold">{{ (isTonKhoTQView() ? getRemainingNumberOfPack(summary) : summary.NumberOfPack) | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold" v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{ summary.NumberOfPackTruck | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold" v-if="!currentPath.includes('ton-kho-tq') && !currentPath.includes('ton-kho-vn')">{{ summary.NumberOfPackInTQ | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold">{{ summary.Deposit | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold">{{ getDisplayWeight(summary) | currency('', 1) }}</td>
                                <td class="text-end font-weight-bold">{{ getDisplayVolume(summary) | currency('', 3) }}</td>
                                <td class="text-end font-weight-bold">{{ summary.TotalFeeWeight | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.ImportTaxAmount | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.VatTaxAmount | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.ServiceFeeAmount | currency }}</td>
                                <td class="text-end font-weight-bold" v-if="adminRole">{{ summary.TotalCostWeight |
                                    currency}}</td>
                                <td class="text-end font-weight-bold" v-if="adminRole">{{ summary.TotalProfit |
                                    currency}}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>

        <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/ma_van_don_mau.xlsx"
            @closePopup="dialogImport = false" @importFile="importFile"></upload-file>

        <!-- Export Options Dialog -->
        <v-dialog v-model="dialogExport" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.select_export_type') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-alert v-if="selectedItems && selectedItems.length > 0" color="info" text
                            icon="mdi-information" class="mb-3">
                            {{ $t('export.export_selected_items', { count: selectedItems.length }) }}
                        </v-alert>
                        <v-alert v-else color="warning" text icon="mdi-information" class="mb-3">
                            {{ $t('export.export_all_items') }}
                        </v-alert>
                        <v-radio-group v-model="selectedExportType">
                            <v-radio v-for="option in exportOptions" :key="option.value" :label="option.text"
                                :value="option.value"></v-radio>
                        </v-radio-group>
                        <v-checkbox v-if="selectedExportType === 'chinh_ngach_vi'" v-model="isSentCustoms" :label="$t('export.send_custom')"></v-checkbox>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialogExport = false">
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn color="primary" @click="confirmExport">
                        {{ $t('actions.export_file') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Quote Edit Dialog -->
        <v-dialog v-model="dialogQuoteEdit" max-width="700px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.edit_quote_info') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="quoteEditForm">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.BrandName"
                                        :label="$t('form.product_brand')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.ProductCapacity"
                                        :label="$t('form.product_capacity')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.ProductMaterial"
                                        :label="$t('form.product_material')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.PackType"
                                        :label="$t('form.pack_type')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.ProductSize"
                                        :label="$t('form.product_size')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model.number="editingQuote.ProductNumber"
                                        :label="$t('form.total_product')"
                                        outlined
                                        dense
                                        type="number"
                                        min="0"
                                        step="1"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="grey darken-1" 
                        text 
                        @click="cancelQuoteEdit"
                        :disabled="savingQuote"
                    >
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        @click="saveQuoteEdit"
                        :loading="savingQuote"
                    >
                        {{ $t('actions.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Truck Creation Dialog -->
        <v-dialog v-model="dialogTruck" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.create_truck') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="truckForm">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="newTruck.LicensePlate"
                                        label="Biển số xe"
                                        :rules="[v => !!v || 'Biển số xe là bắt buộc']"
                                        required
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        v-model="newTruck.Status"
                                        :items="receive_type_list"
                                        item-text="name"
                                        item-value="value"
                                        label="Trạng thái"
                                        outlined
                                        dense
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-alert color="info" text icon="mdi-information" class="mb-0">
                                        Sẽ tạo xe với {{ selectedItems.filter(item => !item.OrderCodes).length }} sản phẩm chưa xếp xe
                                        <span v-if="selectedItems.filter(item => item.OrderCodes).length > 0">
                                            <br/>(Đã loại bỏ {{ selectedItems.filter(item => item.OrderCodes).length }} sản phẩm đã được xếp xe)
                                        </span>
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="grey darken-1" 
                        text 
                        @click="cancelTruckCreation"
                        :disabled="savingTruck"
                    >
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        @click="saveTruck"
                        :loading="savingTruck"
                    >
                        {{ $t('actions.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- TN Product Dialog -->
        <v-dialog v-model="dialogTmdt" max-width="780px" persistent scrollable>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left dark>mdi-local-mall</v-icon>
                    {{ currentItemTmdt.ID ? $t('tmdt_form.title_detail') : $t('tmdt_form.title_create') }}
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeTmdtDialog"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-4">
                    <v-form ref="tmdtForm" lazy-validation>
                        <v-row>
                            <!-- Basic Info -->
                            <v-col cols="12" md="6">
                                <v-card outlined class="mb-3">
                                    <v-card-title class="subtitle-2 font-weight-bold grey lighten-4 py-2">
                                        <v-icon left small color="primary">mdi-information-outline</v-icon>
                                        {{ $t('tmdt_form.general_info') }}
                                    </v-card-title>
                                    <v-card-text class="pt-3">
                                        <v-text-field outlined dense
                                            :label="$t('tmdt_form.tracking_code') + ' *'"
                                            v-model="currentItemTmdt.TrackingCode"
                                            :rules="[v => !!v || $t('tmdt_form.tracking_code_required')]"
                                            prepend-inner-icon="mdi-barcode"
                                            clearable
                                        ></v-text-field>
                                        <v-autocomplete outlined dense
                                            v-model="currentItemTmdt.UID"
                                            :items="customers"
                                            item-value="ID"
                                            item-text="Username"
                                            :label="$t('tmdt_form.customer') + ' *'"
                                            :rules="[v => !!v || $t('tmdt_form.customer_required')]"
                                            prepend-inner-icon="mdi-account"
                                        ></v-autocomplete>
                                        <v-autocomplete outlined dense
                                            v-model="currentItemTmdt.StoreID"
                                            :items="storages"
                                            item-value="ID"
                                            item-text="Name"
                                            :label="$t('tmdt_form.storage') + ' *'"
                                            :rules="[v => !!v || $t('tmdt_form.storage_required')]"
                                            prepend-inner-icon="mdi-store"
                                        ></v-autocomplete>
                                        <v-select outlined dense
                                            v-model="currentItemTmdt.Status"
                                            :items="product_status_list"
                                            item-value="value"
                                            :item-text="p => p.i18n ? $t(p.i18n) : p.name"
                                            :label="$t('tmdt_form.status') + ' *'"
                                            :rules="[v => v !== null && v !== undefined || $t('tmdt_form.status_required')]"
                                            prepend-inner-icon="mdi-circle-slice-8"
                                        ></v-select>
                                        <h-currency-input
                                            :label="$t('tmdt_form.number_of_pack') + ' *'"
                                            v-model="currentItemTmdt.NumberOfPack"
                                            :rules="[v => !!v || $t('tmdt_form.number_of_pack_required')]"
                                            :decimal="0"
                                        ></h-currency-input>
                                        <v-textarea outlined dense
                                            :label="$t('tmdt_form.note')"
                                            v-model="currentItemTmdt.Note"
                                            prepend-inner-icon="mdi-note-text"
                                            rows="2"
                                        ></v-textarea>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <!-- Specs + Timeline -->
                            <v-col cols="12" md="6">
                                <v-card outlined class="mb-3">
                                    <v-card-title class="subtitle-2 font-weight-bold grey lighten-4 py-2">
                                        <v-icon left small color="primary">mdi-cube-outline</v-icon>
                                        {{ $t('tmdt_form.specs') }}
                                    </v-card-title>
                                    <v-card-text class="pt-3">
                                        <v-row dense>
                                            <v-col cols="6">
                                                <h-currency-input :label="$t('tmdt_form.length')" v-model="tmdtLength" :decimal="1" @input="calcTmdtVolume"></h-currency-input>
                                            </v-col>
                                            <v-col cols="6">
                                                <h-currency-input :label="$t('tmdt_form.width')" v-model="tmdtWidth" :decimal="1" @input="calcTmdtVolume"></h-currency-input>
                                            </v-col>
                                            <v-col cols="6">
                                                <h-currency-input :label="$t('tmdt_form.height')" v-model="tmdtHeight" :decimal="1" @input="calcTmdtVolume"></h-currency-input>
                                            </v-col>
                                            <v-col cols="6">
                                                <h-currency-input :label="$t('tmdt_form.weight') + ' *'" v-model="currentItemTmdt.Weight"
                                                    :rules="[v => !!v || $t('tmdt_form.weight_required')]" :decimal="1"></h-currency-input>
                                            </v-col>
                                            <v-col cols="12">
                                                <h-currency-input :label="$t('tmdt_form.volume')" v-model="currentItemTmdt.Volume" :decimal="3" disabled></h-currency-input>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>

                                <v-card outlined v-if="currentItemTmdt.ID">
                                    <v-card-title class="subtitle-2 font-weight-bold grey lighten-4 py-2">
                                        <v-icon left small color="primary">mdi-link-variant</v-icon>
                                        {{ $t('tmdt_form.link_timeline') }}
                                    </v-card-title>
                                    <v-card-text class="pt-2">
                                        <div v-if="currentItemTmdt.BigPackageCode" class="mb-1">
                                            <span class="grey--text caption">{{ $t('tmdt_form.big_package_code') }}: </span>
                                            <span class="font-weight-bold primary--text">{{ currentItemTmdt.BigPackageCode }}</span>
                                        </div>
                                        <div v-if="currentItemTmdt.OrderCodes" class="mb-1">
                                            <span class="grey--text caption">{{ $t('tmdt_form.truck_code') }}: </span>
                                            <span class="font-weight-bold success--text" v-html="currentItemTmdt.OrderCodes"></span>
                                        </div>
                                        <v-divider class="my-2"></v-divider>
                                        <div v-if="currentItemTmdt.CreatedDate" class="d-flex justify-space-between caption py-1">
                                            <span>{{ $t('tmdt_form.date_created') }}</span><span class="font-weight-bold">{{ currentItemTmdt.CreatedDate | display_date('DD-MM-YYYY HH:mm') }}</span>
                                        </div>
                                        <div v-if="currentItemTmdt.StoreCNDate" class="d-flex justify-space-between caption py-1">
                                            <span>{{ $t('tmdt_form.date_store_cn') }}</span><span class="font-weight-bold">{{ currentItemTmdt.StoreCNDate | display_date('DD-MM-YYYY HH:mm') }}</span>
                                        </div>
                                        <div v-if="currentItemTmdt.StoreCNExpDate" class="d-flex justify-space-between caption py-1">
                                            <span>{{ $t('tmdt_form.date_store_cn_exp') }}</span><span class="font-weight-bold">{{ currentItemTmdt.StoreCNExpDate | display_date('DD-MM-YYYY HH:mm') }}</span>
                                        </div>
                                        <div v-if="currentItemTmdt.StoreVNDate" class="d-flex justify-space-between caption py-1">
                                            <span>{{ $t('tmdt_form.date_store_vn') }}</span><span class="font-weight-bold">{{ currentItemTmdt.StoreVNDate | display_date('DD-MM-YYYY HH:mm') }}</span>
                                        </div>
                                        <div v-if="currentItemTmdt.StoreVNExpDate" class="d-flex justify-space-between caption py-1">
                                            <span>{{ $t('tmdt_form.date_store_vn_exp') }}</span><span class="font-weight-bold">{{ currentItemTmdt.StoreVNExpDate | display_date('DD-MM-YYYY HH:mm') }}</span>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="grey lighten-4 pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="grey darken-1" @click="closeTmdtDialog" :disabled="savingTmdt">{{ $t('actions.cancel') }}</v-btn>
                    <v-btn color="primary" @click="saveTmdtItem" :loading="savingTmdt">
                        <v-icon left>mdi-content-save</v-icon>
                        {{ $t('actions.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, makeid } from "@/commons/utils";
import { print_quote_label, print_item_package_labels } from "@/commons/hpod";
import upload_file from "@/components/popups/upload_file";
import {display_color} from "@/commons/formater"
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering,
        "upload-file": upload_file,
    },
    data() {
        return {
            viewName: "product_list",
            view_filters: [],
            dialogImport: false,
            dialogExport: false,
            dialogQuoteEdit: false,
            savingQuote: false,
            dialogTruck: false,
            savingTruck: false,
            dialogTmdt: false,
            savingTmdt: false,
            tmdtLength: 0,
            tmdtWidth: 0,
            tmdtHeight: 0,
            currentItemTmdt: {
                ID: 0,
                UID: null,
                StoreID: null,
                GoodsType: 1,
                TrackingCode: '',
                Weight: 0,
                Volume: 0,
                NumberOfPack: 1,
                Status: 1,
                Note: '',
            },
            newTruck: {
                LicensePlate: '',
                Status: 1, // Xếp xe
                Products: []
            },
            editingQuote: {
                ID: 0,
                BrandName: '',
                ProductCapacity: '',
                ProductMaterial: '',
                PackType: '',
                ProductSize: '',
                ProductNumber: 0
            },
            selectedExportType: 'tieu_ngach',
            isSentCustoms: 0,
            selectedItems: [],
            product_status_list: configs.PRODUCT_STATUS_LIST,
            product_status: configs.PRODUCT_STATUS,
            receive_type_list: configs.RECEIVE_TYPE_LIST,
            receive_type: configs.RECEIVE_TYPE,
            pagination: { ...configs.PAGINATION },
            items_per_page: { ...configs.ITEMS_PER_PAGE },
            filterConditions: [],
            quickFilterConditions: [],
            isUploading: false,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        currentPath() {
            this.view_filters = [];
            this.filterConditions = [];
            this.quickFilterConditions = [];
            this.filter_data();
        },
        storages() {
            let header_item = _.find(this.headers, { value: "StoreID" });
            if (header_item) {
                header_item.values =
                    _.map(this.storages, (item) => {
                        return {
                            value: item.ID,
                            name: item.Name,
                        };
                    }) || [];
            }
        },
        product_types() {
            let header_item = _.find(this.headers, { value: "ProductType" });
            if (header_item) {
                header_item.values =
                    _.map(this.product_types, (item) => {
                        return {
                            value: item.ID,
                            name: item.Name,
                        };
                    }) || [];
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.product.all.data,
            total_rows: state => state.product.all.total,
            summary: state => state.product.all.summary,
            loading: state => state.product.loading,
            storages: state => state.storage.all.data,
            product_types: state => state.productType.all.data,
            customers: state => state.commons.customers,
        }),
        staffStorage() {
            return this.$store.state.authentication.user.storageid;
        },
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
        },
        csRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerSupport;
        },
        roleStoreTQ() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Store;
        },
        roleCustomer() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
        },
        currentPath() {
            return this.$route.path !== undefined && this.$route.path ? this.$route.path : '';
        },
        isNoneOwner() {
            return this.currentPath.includes('hang-khong-ten');
        },
        selectedItemsWeight() {
            return this.selectedItems.reduce((total, item) => total + this.getDisplayWeight(item), 0);
        },
        selectedItemsVolume() {
            return this.selectedItems.reduce((total, item) => total + this.getDisplayVolume(item), 0);
        },
        selectedItemsNumberOfPack() {
            return this.selectedItems.reduce((total, item) => total + this.getDisplayNumberOfPack(item), 0);
        },
        headers() {
            if (this.currentPath.includes('ma-hang-tmdt')) {
                return [
                    { text: this.$t('table_headers.suffix_bill'), value: 'TrackingCode', filterable: true, quickSearch: true, width: '160px', dataType: configs.DATA_TYPE["String"] },
                    { text: this.$t('table_headers.customer_code'), value: 'CustomerName', filterable: true, quickSearch: true, width: '140px', dataType: configs.DATA_TYPE["String"] },
                    { text: this.$t('table_headers.big_package_code'), value: 'BigPackageCode', filterable: true, quickSearch: true, width: '160px', dataType: configs.DATA_TYPE["String"] },
                    { text: this.$t('table_headers.truck_code'), value: 'OrderCodes', filterable: true, quickSearch: true, width: '160px', dataType: configs.DATA_TYPE["String"] },
                    { text: this.$t('table_headers.weight'), value: 'Weight', align: 'end', filterable: true, width: '100px', dataType: configs.DATA_TYPE["Number"] },
                    { text: this.$t('table_headers.dimensions'), value: 'Dimensions', filterable: false, sortable: false, width: '140px', dataType: configs.DATA_TYPE["String"] },
                    { text: this.$t('table_headers.volume'), value: 'Volume', align: 'end', filterable: true, width: '100px', dataType: configs.DATA_TYPE["Number"] },
                    { text: this.$t('table_headers.number_of_pack'), value: 'NumberOfPack', align: 'end', filterable: true, width: '100px', dataType: configs.DATA_TYPE["Number"] },
                    { text: this.$t('table_headers.status'), value: 'Status', filterable: true, width: '150px', values: configs.PRODUCT_STATUS_LIST, dataType: configs.DATA_TYPE["Enum"] },
                    { text: this.$t('table_headers.timeline'), value: 'Timeline', filterable: false, sortable: false, width: '280px', dataType: configs.DATA_TYPE["String"] },
                    { text: this.$t('table_headers.action'), value: "", align: "center", width: "80px", sortable: false, filterable: false, dataType: configs.DATA_TYPE["String"] }
                ];
            }

            let baseHeaders = [
                {
                    text: this.$t('table_headers.customer_code'),
                    value: "CustomerName",
                    filterable: true,
                    quickSearch: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.sale_staff'),
                    value: "SaleName",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.partner_name'),
                    value: "PartnerName",
                    filterable: true,
                    quickSearch: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.quotes'),
                    value: "QuoteCount",
                    filterable: true,
                    width: "120px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.note'),
                    value: "Note",
                    filterable: true,
                    quickSearch: true,
                    width: "100px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.product_name_cn'),
                    value: "ProductNameCN",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.license_plate'),
                    value: "OrderCodes",
                    filterable: true,
                    quickSearch: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.bill_codes'),
                    value: "BillCodes",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.currentPath.includes('ton-kho-tq') || this.currentPath.includes('ton-kho-vn') ? this.$t('table_headers.remaining_pack') : this.$t('table_headers.number_of_pack'),
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    width: "100px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.loaded_package_count'),
                    value: "NumberOfPackTruck",
                    align: "end",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.cn_remaining_packages'),
                    value: "NumberOfPack - NumberOfPackTruck",
                    align: "end",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.suffix_bill'),
                    value: "SuffixBill",
                    filterable: true,
                    quickSearch: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.$t('table_headers.deposit'),
                    value: "Deposit",
                    align: "end",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.weight'),
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    width: "120px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.volume'),
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    width: "120px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.total_fee_weight'),
                    value: "TotalFeeWeight",
                    align: "end",
                    filterable: true,
                    width: "160px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.import_tax_amount'),
                    value: "ImportTaxAmount",
                    align: "end",
                    filterable: true,
                    width: "140px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.vat_tax_amount'),
                    value: "VatTaxAmount",
                    align: "end",
                    filterable: true,
                    width: "120px",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.$t('table_headers.service_fee_amount'),
                    value: "ServiceFeeAmount",
                    align: "end",
                    filterable: true,
                    width: "140px",
                    dataType: configs.DATA_TYPE["Number"]
                }
            ];
            // Xóa 2 cột Số kiện xếp xe và Số kiện tồn kho TQ nếu đang ở trang tồn kho TQ hoặc tồn kho VN
            if(this.currentPath.includes('ton-kho-tq') || this.currentPath.includes('ton-kho-vn')) {
                baseHeaders = baseHeaders.filter(header => header.value !== "NumberOfPackTruck" && header.value !== "NumberOfPack - NumberOfPackTruck");
            }

            // Chỉ thêm 2 cột này nếu là admin
            if (this.adminRole) {
                baseHeaders.push(
                    {
                        text: this.$t('table_headers.total_cost_weight'),
                        value: "TotalCostWeight",
                        align: "end",
                        filterable: true,
                        width: "200px",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: this.$t('table_headers.total_profit'),
                        value: "TotalProfit",
                        align: "end",
                        filterable: true,
                        width: "160px",
                        dataType: configs.DATA_TYPE["Number"]
                    }
                );
            }

            // Thêm các cột còn lại
            baseHeaders.push(
                {
                    text: this.$t('table_headers.is_split_tax'),
                    value: "IsSplitTax",
                    width: "60px",
                    filterable: true,
                    values: [
                        { value: 1, name: this.$t('form.yes') },
                        { value: 0, name: this.$t('form.no') }
                    ],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.receive_date'),
                    value: "ReceiveDate",
                    filterable: true,
                    width: "120px",
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.deliver_date'),
                    value: "StoreCNExpDate",
                    filterable: true,
                    width: "120px",
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: this.$t('table_headers.status'),
                    value: "Status",
                    filterable: true,
                    width: "150px",
                    values: configs.PRODUCT_STATUS_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.store_id'),
                    value: "StoreID",
                    filterable: true,
                    width: "120px",
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.product_type'),
                    value: "ProductType",
                    filterable: true,
                    width: "120px",
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: this.$t('table_headers.action'),
                    value: "",
                    align: "center",
                    width: "100px",
                    sortable: false,
                    filterable: false
                }
            );

            return baseHeaders;
        },
        filter_status() {
            return this.$route.meta && this.$route.meta.package_status ? this.$route.meta.package_status : [];
        },
        exportOptions() {
            return [
                { value: 'tieu_ngach', text: this.$t('form.export_tieu_ngach') },
                { value: 'chinh_ngach', text: this.$t('form.export_chinh_ngach') },
                { value: 'chinh_ngach_vi', text: this.$t('form.export_chinh_ngach_vi') },
            ];
        },
        filter_header() {
            let tmp = [...this.headers];
            tmp.push({
                text: this.$t('export.send_custom'),
                value: "IsSentCustoms",
                filterable: true,
                values: [{ value: 1, name: 'Yes' }, { value: 0, name: 'No' }],
                dataType: configs.DATA_TYPE["Enum"]
            });
            return tmp;
        }
    },
    methods: {
        display_color,
        getProductActions(item) {
            return [
                { label: this.$t('actions.print_label'), variant: 'info', disabled: !item.QuoteID, onClick: () => this.printLabel(item.QuoteID) },
                { label: this.$t('actions.print_temp'), variant: 'info', onClick: () => this.printPackageLabels(item) },
                // { label: this.$t('actions.edit_quote'), variant: 'primary', disabled: !item.QuoteID || item.QuoteID <= 0, onClick: () => this.editQuote(item.QuoteID) },
                { label: this.$t('actions.edit'), variant: 'primary', onClick: () => this.openItem(item.ID) },
                { label: this.$t('actions.delete'), variant: 'danger-outline', hidden: !(this.adminRole || (this.csRole && item.Status == 1)), onClick: () => this.deleteItem(item.ID) }
            ];
        },
        getTmdtActions(item) {
            return [
                { label: this.$t('actions.print_temp'), variant: 'info', onClick: () => this.printPackageLabels(item) },
                { label: this.$t('actions.edit'), variant: 'primary', onClick: () => this.openItem(item.ID) },
                { label: this.$t('actions.delete'), variant: 'danger-outline', hidden: !(this.adminRole || (this.csRole && item.Status == 1)), onClick: () => this.deleteItem(item.ID) }
            ];
        },
        triggerFileUpload() {
            this.$refs.fileInput.click();
        },
        async onFileSelected(event) {
            const file = event.target.files[0];
            if (!file) return;
            
            const formData = new FormData();
            formData.append('file', file);
            
            this.isUploading = true;
            try {
                const response = await this.$store.dispatch('product/import_excel_tmdt', formData);
                if (response && response.success) {
                    const result = response.data;
                    sendSuccessNotice(`Import thành công ${result.success_count} dòng.`);
                    if (result.errors && result.errors.length > 0) {
                        sendErrorNotice(`Có ${result.errors.length} dòng lỗi, xem console log để biết chi tiết.`);
                        console.error('Import Errors:', result.errors);
                    }
                    this.filter_data();
                } else {
                    sendErrorNotice(response.reason || 'Import thất bại');
                }
            } catch (error) {
                console.error(error);
                sendErrorNotice('Có lỗi xảy ra khi import');
            } finally {
                this.isUploading = false;
                event.target.value = ''; // Reset input
            }
        },
        toNumber(value) {
            const num = parseFloat(value);
            return Number.isFinite(num) ? num : 0;
        },
        toInt(value) {
            const num = parseInt(value);
            return Number.isFinite(num) ? num : 0;
        },
        isTonKhoTQView() {
            return this.currentPath.includes('ton-kho-tq');
        },
        getRemainingNumberOfPack(item) {
            const numberOfPack = this.toInt(item.NumberOfPack);
            const numberOfPackTruck = this.toInt(item.NumberOfPackTruck);
            const remaining = numberOfPack - numberOfPackTruck;
            return remaining > 0 ? remaining : 0;
        },
        getRemainingRatio(item) {
            const numberOfPack = this.toInt(item.NumberOfPack);
            if (numberOfPack <= 0) {
                return 0;
            }
            return this.getRemainingNumberOfPack(item) / numberOfPack;
        },
        getDisplayNumberOfPack(item) {
            if (this.isTonKhoTQView()) {
                return this.getRemainingNumberOfPack(item);
            }
            return this.toInt(item.NumberOfPack);
        },
        getDisplayWeight(item) {
            const weight = this.toNumber(item.Weight);
            if (!this.isTonKhoTQView()) {
                return weight;
            }
            return weight * this.getRemainingRatio(item);
        },
        getDisplayVolume(item) {
            const volume = this.toNumber(item.Volume);
            if (!this.isTonKhoTQView()) {
                return volume;
            }
            return volume * this.getRemainingRatio(item);
        },
        changeStatusSelectedProducts() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn sản phẩm để chuyển trạng thái!');
                return;
            }
            // Ví dụ: chuyển trạng thái sang "Đã giao" (Status = 3)
            const ids = this.selectedItems.map(item => item.ID);
            // Có thể mở dialog chọn trạng thái, ở đây demo cứng Status = 3
            // nhap_kho_tq: 1,
            // cho_xep_xe: 2,
            // xep_xe: 3,
            // cho_thong_quan_tq: 4,
            // kiem_hoa: 5,
            // cho_thong_quan_vn: 6,
            // nhap_kho_vn: 7,
            // xuat_thieu: 8,
            // xuat_du: 9
            let nextStatus = this.product_status.cho_xep_xe;
            const payload = { ids, Status: nextStatus };
            this.$store.dispatch("product/setDetail", { data: payload, id: ids[0] })
                .then(() => {
                    // this.selectedItems = [];
                    sendSuccessNotice('Chuyển trạng thái thành công!');
                })
                .catch(() => {
                    sendErrorNotice('Có lỗi khi chuyển trạng thái!');
                });
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            if (this.currentPath.includes('hang-khong-ten')) {
                param.filter.push({
                    column: "UID",
                    value: 0,
                    condition: "equal",
                });
                param.action = "hang-khong-ten";
            }
            if (this.filter_status && this.filter_status.length > 0) {
                param.filter.push({
                    column: "Status",
                    value: this.filter_status,
                    condition: "in",
                });
            }
            if (this.currentPath.includes('ton-kho-tq')) {
                param.action = "ton-kho-tq";
            }
            else if (this.currentPath.includes('ton-kho-vn')) {
                param.action = "ton-kho-vn";
            }
            else if (this.currentPath.includes('ma-hang-tmdt')) {
                param.action = "ma-hang-tmdt";
            }
            this.$store.dispatch("product/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        printLabel(quote_id) {
            this.$store.dispatch("quote/getDetail", quote_id).then((quoteItem) => {
                print_quote_label(quoteItem);
            });
        },
        printPackageLabels(item) {
            const storage = (this.storages || []).find(s => s.ID === item.StoreID)
                || configs.LOCATION_STORE.find(s => s.value === item.StoreID)
                || {};

            const ok = print_item_package_labels(item, storage);
            if (!ok) {
                sendErrorNotice('Không có kiện để in tem cho sản phẩm này.');
            }
        },
        editQuote(quoteId) {
            if (!quoteId || quoteId <= 0) {
                sendErrorNotice(this.$t('errors.product_no_quote'));
                return;
            }
            
            // Load thông tin khai báo từ API
            this.$store.dispatch("quote/getDetail", quoteId).then((quoteItem) => {
                this.editingQuote = {
                    ID: quoteItem.ID || quoteId,
                    BrandName: quoteItem.BrandName || '',
                    ProductCapacity: quoteItem.ProductCapacity || '',
                    ProductMaterial: quoteItem.ProductMaterial || '',
                    PackType: quoteItem.PackType || '',
                    ProductSize: quoteItem.ProductSize || '',
                    ProductNumber: quoteItem.ProductNumber || 0
                };
                this.dialogQuoteEdit = true;
            }).catch(error => {
                console.error('Error loading quote:', error);
                sendErrorNotice(this.$t('errors.cannot_load_quote_info'));
            });
        },
        cancelQuoteEdit() {
            this.dialogQuoteEdit = false;
            this.resetEditingQuote();
        },
        resetEditingQuote() {
            this.editingQuote = {
                ID: 0,
                BrandName: '',
                ProductCapacity: '',
                ProductMaterial: '',
                PackType: '',
                ProductSize: '',
                ProductNumber: 0
            };
        },
        async saveQuoteEdit() {
            if (!this.$refs.quoteEditForm.validate()) {
                return;
            }
            
            this.savingQuote = true;
            
            try {
                const updateData = {
                    BrandName: this.editingQuote.BrandName,
                    ProductCapacity: this.editingQuote.ProductCapacity,
                    ProductMaterial: this.editingQuote.ProductMaterial,
                    PackType: this.editingQuote.PackType,
                    ProductSize: this.editingQuote.ProductSize,
                    ProductNumber: this.editingQuote.ProductNumber
                };
                
                await this.$store.dispatch("quote/setDetail", {
                    data: updateData,
                    id: this.editingQuote.ID
                });
                
                sendSuccessNotice(this.$t('success.quote_updated'));
                this.dialogQuoteEdit = false;
                this.resetEditingQuote();
                
                // Refresh danh sách sản phẩm để hiển thị thông tin mới
                this.filter_data();
                
            } catch (error) {
                console.error('Error updating quote:', error);
                sendErrorNotice(this.$t('errors.cannot_update_quote'));
            } finally {
                this.savingQuote = false;
            }
        },
        openItem: function (id) {
            const isTmdt = this.currentPath.includes('ma-hang-tmdt');
            if (isTmdt) {
                if (this.roleCustomer) {
                    this.$router.push({
                        name: 'CustomerProductDetailTmdt',
                        params: { id: id || 'new' }
                    });
                    return;
                }
                this.openTmdtDialog(id);
            } else {
                this.$router.push({
                    name: this.roleCustomer ? 'CustomerProductDetail' : 'ProductDetail',
                    params: { id: id || 'new' }
                });
            }
        },
        openTmdtDialog(id) {
            this.tmdtLength = 0;
            this.tmdtWidth = 0;
            this.tmdtHeight = 0;
            if (!id) {
                // New item
                this.currentItemTmdt = {
                    ID: 0,
                    UID: null,
                    StoreID: null,
                    GoodsType: 1,
                    TrackingCode: '',
                    Weight: 0,
                    Volume: 0,
                    NumberOfPack: 1,
                    Status: 1,
                    Note: '',
                };
                this.dialogTmdt = true;
            } else {
                // Load existing item
                this.$store.dispatch('product/getDetail', id).then(item => {
                    const data = item && item.data ? item.data : item;
                    this.currentItemTmdt = { ...data };
                    // Parse dimensions from Packages JSON
                    if (data.Packages) {
                        try {
                            const pkgs = JSON.parse(data.Packages);
                            if (pkgs && pkgs.length > 0) {
                                this.tmdtLength = pkgs[0].Length || 0;
                                this.tmdtWidth = pkgs[0].Width || 0;
                                this.tmdtHeight = pkgs[0].Height || 0;
                            }
                        } catch (e) { /* ignore */ }
                    }
                    this.dialogTmdt = true;
                }).catch(() => {
                    sendErrorNotice(this.$t('tmdt_form.load_failed'));
                });
            }
        },
        closeTmdtDialog() {
            this.dialogTmdt = false;
            if (this.$refs.tmdtForm) this.$refs.tmdtForm.resetValidation();
        },
        calcTmdtVolume() {
            const l = Number(this.tmdtLength || 0);
            const w = Number(this.tmdtWidth || 0);
            const h = Number(this.tmdtHeight || 0);
            this.currentItemTmdt.Volume = parseFloat(((l * w * h) / 1000000).toFixed(6));
        },
        async saveTmdtItem() {
            if (!this.$refs.tmdtForm.validate()) return;
            this.savingTmdt = true;
            try {
                const pkgs = [{
                    Length: Number(this.tmdtLength || 0),
                    Width: Number(this.tmdtWidth || 0),
                    Height: Number(this.tmdtHeight || 0),
                    Weight: Number(this.currentItemTmdt.Weight || 0),
                    NumberOfPack: Number(this.currentItemTmdt.NumberOfPack || 1)
                }];
                const data = {
                    ...this.currentItemTmdt,
                    GoodsType: 1,
                    Packages: JSON.stringify(pkgs),
                };
                const ret = await this.$store.dispatch('product/setDetail', { data, id: data.ID });
                const saved = ret && ret.data ? ret.data : ret;
                if (!saved || _.isEmpty(saved)) {
                    sendErrorNotice(this.$t('tmdt_form.load_failed'));
                } else {
                    sendSuccessNotice(this.$t('tmdt_form.save_success'));
                    this.closeTmdtDialog();
                    this.filter_data();
                }
            } catch (error) {
                console.error('Save TMDT error:', error);
                sendErrorNotice(this.$t('tmdt_form.save_failed'));
            } finally {
                this.savingTmdt = false;
            }
        },
        deleteItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        saveItem(item) {
            this.$store.dispatch("product/setDetail", { data: item, id: item.ID });
        },
        importFileDialog() {
            this.dialogImport = true;
        },
        importFile(filelist) {
            for (const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("product/import_data", formData);
            }
            this.dialogImport = false;
        },
        exportData() {
            // Show export options dialog
            this.dialogExport = true;
        },
        exportSelectedItems() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn ít nhất một sản phẩm để xuất Excel!');
                return;
            }
            // Show export options dialog cho selected items
            this.dialogExport = true;
        },
        confirmExport() {
            var param = {
                exportType: this.selectedExportType
            };

            const hasSelectedItems = this.selectedItems && this.selectedItems.length > 0;

            // Nếu có selected items thì export theo selection, ngược lại export theo filter
            if (hasSelectedItems) {
                // Export theo selected items
                param.selectedIds = this.selectedItems.map(item => item.ID);
            } else {
                // Export theo filter như cũ
                param.pagination = this.pagination;
                param.filter = this.filterConditions;
                param.quickFilter = this.quickFilterConditions;
            }

            param.isSentCustoms = this.isSentCustoms ? 1 : 0;

            this.dialogExport = false;

            // Choose the appropriate export function based on selection
            const exportPromise = this.selectedExportType === 'tieu_ngach'
                ? this.$store.dispatch("product/exportTieuNgach", param) : this.selectedExportType === 'chinh_ngach' ?
                    this.$store.dispatch("product/exportChinhNgach", param)
                : this.$store.dispatch("product/exportChinhNgachVi", param);

            // exportPromise.then(() => {
            //     // Clear selection sau khi export thành công
            //     if (hasSelectedItems) {
            //         this.selectedItems = [];
            //         this.filter_data();
            //     }
            // }).catch(error => {
            //     console.error('Export error:', error);
            // });
        },
        loadQuotesByCustomer(customerId) {
            if (!customerId) {
                this.availableQuotes = [];
                return;
            }

            this.loadingQuotes = true;
            this.$store.dispatch("quote/getQuotesByCustomer", customerId)
                .then(quotes => {
                    this.availableQuotes = quotes || [];
                })
                .catch(error => {
                    console.error('Error loading quotes:', error);
                    this.availableQuotes = [];
                })
                .finally(() => {
                    this.loadingQuotes = false;
                });
        },
        onCustomerChange() {
            // Reset quote khi khách hàng thay đổi
            this.currentItem.QuoteID = null;
            if (this.currentItem.UID) {
                this.loadQuotesByCustomer(this.currentItem.UID);
            } else {
                this.availableQuotes = [];
            }
        },
        quoteFilter(item, queryText, itemText) {
            if (!queryText) return true;

            const searchText = queryText.toLowerCase();
            const hsCode = (item.HsCode || '').toLowerCase();
            const productInfo = (item.ProductInfo || '').toLowerCase();

            return hsCode.includes(searchText) || productInfo.includes(searchText);
        },
        openTruckDialog() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn ít nhất một sản phẩm để xếp xe!');
                return;
            }
            
            // Chỉ lấy các sản phẩm chưa được xếp xe (OrderCodes là null hoặc rỗng)
            const unassignedItems = this.selectedItems.filter(item => !item.OrderCodes);
            
            if (unassignedItems.length === 0) {
                sendErrorNotice('Tất cả sản phẩm đã chọn đã được xếp xe rồi!');
                return;
            }
            
            // Hiển thị thông báo nếu có sản phẩm đã được xếp xe
            const assignedCount = this.selectedItems.length - unassignedItems.length;
            if (assignedCount > 0) {
                sendSuccessNotice(`Đã loại bỏ ${assignedCount} sản phẩm đã được xếp xe. Còn ${unassignedItems.length} sản phẩm có thể xếp xe.`);
            }
            
            this.dialogTruck = true;
        },
        cancelTruckCreation() {
            this.dialogTruck = false;
            this.resetNewTruck();
        },
        resetNewTruck() {
            this.newTruck = {
                LicensePlate: '',
                Status: 1, // Xếp xe
                Products: []
            };
        },
        async saveTruck() {
            if (!this.$refs.truckForm.validate()) {
                return;
            }
            
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn ít nhất một sản phẩm!');
                return;
            }
            
            // Chỉ lấy các sản phẩm chưa được xếp xe (OrderCodes là null hoặc rỗng)
            const unassignedItems = this.selectedItems.filter(item => !item.OrderCodes);
            
            if (unassignedItems.length === 0) {
                sendErrorNotice('Không có sản phẩm nào chưa được xếp xe!');
                return;
            }
            
            this.savingTruck = true;
            
            try {
                const truckData = {
                    LicensePlate: this.newTruck.LicensePlate,
                    Status: this.newTruck.Status,
                    Products: unassignedItems.map(item => item.ID)
                };
                
                const result = await this.$store.dispatch("order/setDetail", {
                    data: truckData,
                    id: 0
                });
                
                sendSuccessNotice('Tạo xe hàng thành công!');
                this.dialogTruck = false;
                this.resetNewTruck();
                this.selectedItems = [];
                
                // Refresh danh sách sản phẩm
                this.filter_data();
                
                // Chuyển đến trang chi tiết xe nếu muốn
                if (result && result.ID) {
                    const shouldNavigate = confirm('Xe hàng đã được tạo. Bạn có muốn xem chi tiết xe không?');
                    if (shouldNavigate) {
                        this.$router.push({ name: 'TruckDetail', params: { Pid: result.ID } });
                    }
                }
                
            } catch (error) {
                console.error('Error creating truck:', error);
                sendErrorNotice('Có lỗi khi tạo xe hàng!');
            } finally {
                this.savingTruck = false;
            }
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {
            invisibleCreateButton: this.roleCustomer,
            invisibleImportButton: this.roleCustomer,
            invisibleExportButton: this.roleCustomer,
        });
        this.$store.dispatch("storage/getList");
        this.$store.dispatch("productType/getList");
        this.$store.dispatch("commons/getAllCustomer");
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_IMPORT_ACTION", this.importFileDialog);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("product/removeDetail", id);
        });
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
        this.selectedItems = [];
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_IMPORT_ACTION");
        this.$root.$off("REQUEST_EXPORT_ACTION");
    }
};
</script>
<style scoped>
.thumbnail-img {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s;
}

.thumbnail-img:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}
</style>
